module.exports = __webpack_public_path__ + "static/img/categories2.1f0ae7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/categories2.png
// module id = 1Z1F
// module chunks = 1